// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2DV-3","signatureBlock":"Footer_signatureBlock__3ti1n","signature":"Footer_signature__1lXls"};